<div class="launch-buttons-container">
  <div class="split-button-container">
    <button mat-flat-button class="launch-button" (click)="launch()">
      <span translate="PRESENTER.LAUNCH"></span>
    </button>

    <button mat-flat-button class="dropdown-button" [matMenuTriggerFor]="menu">
      <gb-icon icon="keyboard_arrow_down" [library]="IconLibrary.material"></gb-icon>
    </button>
  </div>

  <mat-menu #menu="matMenu">
    <!--TODO GB-12549-->
    <!--<button mat-menu-item (click)="presenterView()" translate="PRESENTER.PRESENTER_VIEW"></button>-->
    <button mat-menu-item (click)="copyLink()" translate="PRESENTER.COPY_LINK"></button>
    <button mat-menu-item (click)="saveAsTemplate()" translate="PRESENTER.SAVE_AS_TEMPLATE"></button>
  </mat-menu>
  <div>
    <button mat-stroked-button (click)="preview.emit()">
      <div class="preview-button">
        <span translate="PRESENTER.PREVIEW"></span>
      </div>
    </button>
  </div>
</div>
